import { render, staticRenderFns } from "./AddRecipientStep.vue?vue&type=template&id=0893e43c&scoped=true"
import script from "./AddRecipientStep.vue?vue&type=script&lang=js"
export * from "./AddRecipientStep.vue?vue&type=script&lang=js"
import style0 from "./AddRecipientStep.vue?vue&type=style&index=0&id=0893e43c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0893e43c",
  null
  
)

export default component.exports